import type { companies as en } from '@/i18n/locales/en/companies';
import type { Translation } from '@/i18n/types';

export const companies: Translation<typeof en> = {
  list: {
    title: 'Empresas',
    newCompany: 'Nueva empresa',
    empty: 'No hay empresas visibles para ti.',
    name: 'Nombre',
    created: 'Creada',
    rowsLabel: 'las empresas',
    healthTitle: 'Salud de la organización',
    healthCompanies: 'Empresas',
    healthEditions: 'Ediciones',
    healthPilots: 'Pilotos',
    healthPilotsLabel: 'el resumen de pilotos',
    healthActivePilotCount: '{{count}} empresas con un piloto activo',
  },
  detail: {
    thisCompany: 'empresa',
    rename: 'Cambiar nombre',
    companyAdmins: 'Administradores de la empresa',
    delete: 'Eliminar',
    departmentsTitle: 'Departamentos',
    newDepartment: 'Nuevo departamento',
    departmentsEmpty: 'Aún no hay departamentos.',
    departmentsLabel: 'los departamentos',
    name: 'Nombre',
    statistics: 'Estadísticas',
    collectiveConsent: 'Consentimiento colectivo',
    inForce: 'vigente',
    settingsTitle: 'Ajustes',
    settingsLabel: 'los ajustes',
    change: 'Cambiar',
    minGroupSizeLabel: 'Tamaño mínimo del grupo para agregados:',
    systemDefault: 'valor predeterminado del sistema',
    companyOverride: 'valor específico de la empresa',
    domainsTitle: 'Dominios de correo',
    domainsLabel: 'los dominios',
    manage: 'Gestionar',
    domainsEmpty: 'No hay dominios registrados.',
    membersTitle: 'Miembros',
    membersLabel: 'los miembros',
    addPerson: 'Añadir persona',
    membersEmpty: 'No hay miembros.',
    email: 'Correo electrónico',
    login: 'Acceso',
    source: 'Origen',
    actions: 'Acciones',
    yes: 'sí',
    no: 'no',
  },
  form: {
    newTitle: 'Nueva empresa',
    name: 'Nombre',
    cancel: 'Cancelar',
    create: 'Crear empresa',
    editTitle: 'Cambiar el nombre de la empresa',
    save: 'Guardar',
    deleteTitle: 'Eliminar empresa',
    deleteLead:
      'Eliminar {{name}} también termina sus dominios y filas de pertenencia. Esto no se puede deshacer. Escribe el nombre de la empresa para confirmar.',
    companyNameLabel: 'Nombre de la empresa',
    deletePermanently: 'Eliminar definitivamente',
    settingsTitle: 'Umbral de agregación',
    settingsLead:
      'El tamaño mínimo del grupo por debajo del cual no se muestran los agregados. Déjalo vacío para volver al valor predeterminado del sistema. La API impone un límite mínimo absoluto.',
    minGroupSize: 'Tamaño mínimo del grupo',
    domainsTitle: 'Dominios de correo',
    domainsLead:
      'Una dirección verificada en uno de estos dominios inscribe a su titular en esta empresa al iniciar sesión. Las pertenencias existentes se mantienen cuando se elimina un dominio.',
    remove: 'Quitar',
    addDomain: 'Añadir dominio',
    add: 'Añadir',
    backToCompany: 'Volver a la empresa',
  },
  health: {
    title: 'Salud de la organización',
    edition: 'Edición',
    editionFit: 'Fit',
    editionSoccer: 'Soccer',
    members: 'Miembros',
    pilotsTitle: 'Pilotos',
    pilotsLabel: 'el estado de los pilotos',
    noPilots: 'Todavía no hay pilotos.',
    activeCount: '{{count}} activos',
    scaledCount: '{{count}} escalados',
    totalCount: '{{count}} en total',
    viewAllPilots: 'Ver todos los pilotos',
  },
};
